import { Component, Fragment, createContext, useContext, useEffect } from 'react';
import { Prompt } from "react-router-dom";
import PropTypes from 'prop-types';

export const HasUnsavedChangesContext = createContext({ hasUnsavedChangesChanged: ((x) => undefined) });

export const HasUnsavedChangesProvider = ({ children, hasUnsavedChangesChanged }) => {
  return (
      <HasUnsavedChangesContext.Provider value= {{ hasUnsavedChangesChanged: hasUnsavedChangesChanged }} >
          {children}
      </HasUnsavedChangesContext.Provider>
  );
};

export const FormPrompt = ({ hasUnsavedChanges }) => {
  const ctx = useContext(HasUnsavedChangesContext);

  useEffect(() => {
    ctx.hasUnsavedChangesChanged(hasUnsavedChanges);

    const onBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = "";
      }
    };
    window.addEventListener("beforeunload", onBeforeUnload);
 
    return () => {
      window.removeEventListener("beforeunload", onBeforeUnload);
    };

  }, [hasUnsavedChanges, ctx]);
 
  return <Prompt when={hasUnsavedChanges} message="Are you sure you want to leave? There are unsaved changes" />;
};

export function monitorChangesOn(WrappedComponent) {
  return class ChangesWatcher extends Component {
    static propTypes = {
      areThereAnyChanges: PropTypes.bool.isRequired,
    };

    render() {
      return (
        <Fragment>
          <FormPrompt hasUnsavedChanges = {this.props.areThereAnyChanges} />
          <WrappedComponent {...this.props} />
        </Fragment>
      );
    }
  };
}
